import { Dexie, type EntityTable } from 'dexie';

interface ScanSite {
  id: string;
  name: string;
  isQuarantineEnabled: boolean;
  isOnHoldOptionEnabled: boolean;
}

interface Segment {
  serialNumber: string;
  segmentType: string;
  status?: string | undefined;
  ringId?: string | null | undefined;
  virtualRingNumber?: number | undefined;
  desynchronizedAt: string | null;
}

interface Ring {
  id: string;
  number: number;
  createdAt: string;
}

interface SegmentDrawConfig {
  label: string;
}

const db = new Dexie('scanDatabase') as Dexie & {
  scanSites: EntityTable<ScanSite, 'id'>;
  segments: EntityTable<Segment, 'serialNumber'>;
  rings: EntityTable<Ring, 'id'>;
  segmentDrawConfigs: EntityTable<SegmentDrawConfig, 'label'>;
};

db.version(1).stores({
  scanSites: 'id, name', // primary key "id" (for the runtime!)
  segments: 'serialNumber, segmentType, status, ringId, desynchronizedAt',
  rings: 'id, number, createdAt',
  segmentDrawConfigs: 'label',
});

db.version(2).stores({
  segments:
    'serialNumber, segmentType, status, ringId, virtualRingNumber, desynchronizedAt',
});

db.version(3)
  .stores({
    scanSites: 'id, name, isQuarantineEnabled',
  })
  .upgrade((tx) => {
    return tx
      .table('scanSites')
      .toCollection()
      .modify({ isQuarantineEnabled: true });
  });

db.version(4)
  .stores({
    scanSites: 'id, name, isQuarantineEnable, isOnHoldOptionEnabled',
  })
  .upgrade((tx) => {
    return tx
      .table('scanSites')
      .toCollection()
      .modify({ isOnHoldOptionEnabled: false });
  });

export { type Ring, type ScanSite, type Segment, db };
